module.exports = "<div>{{address.postalCode}}</div>\r\n<div>{{address.state}}</div>\r\n<div>{{address.cityKanji ? address.cityKanji : address.city}}</div>\r\n<div>{{address.addressLine1Kanji ? address.addressLine1Kanji : address.addressLine1}}</div>\r\n<div>{{address.addressLine2Kanji ? address.addressLine2Kanji : address.addressLine2}}</div>\r\n<div>{{address.addressLine3Kanji ? address.addressLine3Kanji : address.addressLine}}</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./app/customer/js/src/edge/platform/widgets/inputs/templates/address-summary-BigToSmall.html
// module id = 405
// module chunks = 0